import { getBaseURL } from '@/features/navigation/utils/url-helpers';
import { AppNextLink } from '@/features/app-next-link';
import { IconArrowSquareLeft } from '@/components/svg-symbols/icons';
import { PLPPages } from '@/app/(plp)/types';
import usePDPData from '../../_utils/use-pdp-data';
function Breadcrumb() {
  const {
    data
  } = usePDPData();
  if (!data?.breadcrumb?.length) return null;
  const populatedItems = data.breadcrumb?.map(({
    nameFa
  }, index) => {
    return {
      title: nameFa,
      url: `/${getBaseURL({
        page: PLPPages.Categories,
        basicMetas: {
          breadcrumb: data.breadcrumb?.slice(0, index + 1)
        }
      })}`
    };
  });
  return <div className='pdp-container hide-scrollbar flex flex-row items-center overflow-x-auto whitespace-nowrap' data-sentry-component="Breadcrumb" data-sentry-source-file="breadcrumb.tsx">
            {populatedItems.map((item, i) => <span key={item.title} className='flex items-center gap-0.5 whitespace-nowrap'>
                    <AppNextLink prefetch={false} href={item.url} className='text-caption-12 text-text-darkGray lg:text-body-14'>
                        {item.title}
                    </AppNextLink>
                    {populatedItems.length !== i + 1 && <IconArrowSquareLeft className='h-5 w-5 text-text-darkGray' />}
                </span>)}
        </div>;
}
export default Breadcrumb;